/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy changes driver prices after each race based on their Points Per Million (PPM) averaged over the last 3 races.`)
};

const es_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy cambia los precios de los pilotos después de cada carrera según sus Puntos Por Millón (PPM) promediados en las últimas 3 carreras.`)
};

const de_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy ändert die Fahrerpreise nach jedem Rennen basierend auf den Punkten pro Million (PPM) im Durchschnitt der letzten 3 Rennen.`)
};

const nl_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy wijzigt coureursprijzen na elke race op basis van Punten Per Miljoen (PPM) gemiddeld over de laatste 3 races.`)
};

const fr_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy modifie les prix des pilotes après chaque course selon leurs Points Par Million (PPM) moyennés sur les 3 dernières courses.`)
};

const it_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy cambia i prezzi dei piloti dopo ogni gara in base ai Punti Per Milione (PPM) mediati sulle ultime 3 gare.`)
};

const pt_br2_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O F1 Fantasy muda os preços dos pilotos após cada corrida com base nos Pontos Por Milhão (PPM) calculados sobre as últimas 3 corridas.`)
};

const pt_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O F1 Fantasy altera os preços dos pilotos após cada corrida com base nos Pontos Por Milhão (PPM) calculados sobre as últimas 3 corridas.`)
};

const ja_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasyは各レース後、直近3レースの平均PPM（Points Per Million）に基づいてドライバー価格を変更します。`)
};

const zh_f1_budget_prob_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy 根据最近3场比赛的平均百万积分（PPM）在每场比赛后调整车手价格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_prob_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_prob_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_prob_p1", locale)
	if (locale === "en") return en_f1_budget_prob_p1(inputs)
	if (locale === "es") return es_f1_budget_prob_p1(inputs)
	if (locale === "de") return de_f1_budget_prob_p1(inputs)
	if (locale === "nl") return nl_f1_budget_prob_p1(inputs)
	if (locale === "fr") return fr_f1_budget_prob_p1(inputs)
	if (locale === "it") return it_f1_budget_prob_p1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_prob_p1(inputs)
	if (locale === "pt") return pt_f1_budget_prob_p1(inputs)
	if (locale === "ja") return ja_f1_budget_prob_p1(inputs)
	return zh_f1_budget_prob_p1(inputs)
};